import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const Toolsbar = () => {
    const navigate = useNavigate();
    const [token, setToken] = React.useState<string | null>(null);

    useEffect(() => {
        const token = localStorage.getItem("user_token") || localStorage.getItem("customer_token");
        setToken(token);
    });

    return (
        <>
            {token ? (
                <nav className="navbar navbar-expand-lg fixed-top bg-light border-bottom">
                    <div className="container d-flex justify-content-between items-center">
                        <div
                            style={{width: 100}}
                        >
                            
                        </div>
                        <a
                            className="navbar-brand text-white d-flex flex-row align-items-center"
                            href="/"
                        >
                            <img
                                src="/icon.png"
                                alt="XCEES"
                                width={30}
                                height={30}
                            />
                        </a>
                        <button
                            className="btn"
                            onClick={() => {
                                localStorage.removeItem("token");
                                localStorage.removeItem("customer_token");
                                navigate("/login", { replace: true });
                            }}
                        >
                            <i className="bi bi-box-arrow-left mx-3"></i>
                            Logout
                        </button>
                    </div>
                </nav>
            ) : (
                <></>
            )}
        </>
    );
};

export default Toolsbar;
